import { useState } from 'react';
import classNames from 'classnames';
import { IconTiersCircle } from '@medifind/icons';
import { useMediaQueryDown } from '@medifind/utils';
import MFLink from '../MFLink';
import styles from './TiersExplanation.module.scss';

const TiersExplanation = ({}) => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQueryDown('sm');
  return (
    <div className={styles['tiers__container']}>
      <div>
        <IconTiersCircle />
      </div>
      <MFLink className={classNames(styles['tiers__toggle'], { [classNames(styles['open'])]: open })} onClick={() => setOpen(!open)}>
        <div className={styles['tiers__header']}>What does Elite, Distinguished, Advanced, Experienced mean?</div>
      </MFLink>
      {open && (
        <div className={styles['tiers__body']}>
          MediFind expertise levels show the amount of experience a provider has for a specific condition or procedure. These levels are
          determined by various sources such as medical journals and direct patient experience.{' '}
          <MFLink className={styles['tiers__link']} to="https://www.medifind.com/how-medifind-works" target="_blank">
            {isMobile ? 'Learn more about expertise levels' : 'Learn more'}
          </MFLink>
        </div>
      )}
    </div>
  );
};

export { TiersExplanation as default, TiersExplanation };
